import { Popover, PopoverContent, PopoverTrigger } from "@components/ui/popover";

interface TruncatedListProps {
  items: string[];
  maxVisible?: number;
  separator?: string;
}

export const TruncatedList = ({ items, maxVisible = 2, separator = ", " }: TruncatedListProps) => {
  if (items.length === 0) {
    return null;
  }

  if (items.length <= maxVisible) {
    return <>{items.join(separator)}</>;
  }

  const visibleItems = items.slice(0, 1);
  const remainingItems = items.slice(1);
  const remainingCount = remainingItems.length;

  return (
    <span>
      {visibleItems.join(separator)}
      {" et "}
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" className="cursor-pointer underline decoration-dotted underline-offset-2">
            {remainingCount} autre{remainingCount > 1 ? "s" : ""}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-3">
          <ul className="space-y-1 text-sm">
            {remainingItems.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </PopoverContent>
      </Popover>
    </span>
  );
};
